import React from 'react';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
`;

const LabelBar = styled.div<{ $radius: number; $fontSize: number }>`
  background: #566f8d;
  color: #fff;
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  text-align: center;
  padding: ${({ $fontSize }) => ($fontSize <= 11 ? '3px 6px' : '6px 12px')};
  border-radius: ${({ $radius }) => `${$radius}px ${$radius}px 0 0`};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Image = styled.div<{ imageUrl?: string; hasLabel?: boolean; $radius: number }>`
  width: 100%;
  height: 0;
  padding-bottom: 75%;
  position: relative;
  background-image: ${({ imageUrl }) => (imageUrl ? `url(${imageUrl})` : 'none')};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  border-radius: ${({ hasLabel, $radius }) => (hasLabel ? `0 0 ${$radius}px ${$radius}px` : `${$radius}px`)};
  cursor: pointer;
`;

interface VehicleImageCardProps {
  imageUrl?: string;
  label?: React.ReactNode;
  onClick?: () => void;
  badge?: React.ReactNode;
  borderRadius?: number;
  labelFontSize?: number;
}

const VehicleImageCard = ({ imageUrl, label, onClick, badge, borderRadius = 30, labelFontSize = 16 }: VehicleImageCardProps) => (
  <ImageWrapper>
    {label && <LabelBar $radius={borderRadius} $fontSize={labelFontSize}>{label}</LabelBar>}
    <Image imageUrl={imageUrl} hasLabel={!!label} onClick={onClick} $radius={borderRadius}>
      {badge}
    </Image>
  </ImageWrapper>
);

export default VehicleImageCard;
